import { lazy } from 'react';
const MyListPage = lazy(() => import(/* webpackChunkName: "my-list" */ '.'));
export default MyListPage;
